var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 2.66666L6.77665 6.47695C7.21743 6.7855 7.43783 6.93977 7.67755 6.99953C7.8893 7.05231 8.11078 7.05231 8.32253 6.99953C8.56226 6.93977 8.78265 6.7855 9.22343 6.47695L14.6667 2.66666M4.53337 11.3333H11.4667C12.5868 11.3333 13.1469 11.3333 13.5747 11.1153C13.951 10.9236 14.257 10.6176 14.4487 10.2413C14.6667 9.81348 14.6667 9.25343 14.6667 8.13332V3.86666C14.6667 2.74655 14.6667 2.1865 14.4487 1.75868C14.257 1.38235 13.951 1.07639 13.5747 0.884643C13.1469 0.666656 12.5868 0.666656 11.4667 0.666656H4.53337C3.41327 0.666656 2.85322 0.666656 2.42539 0.884643C2.04907 1.07639 1.74311 1.38235 1.55136 1.75868C1.33337 2.1865 1.33337 2.74655 1.33337 3.86666V8.13332C1.33337 9.25343 1.33337 9.81348 1.55136 10.2413C1.74311 10.6176 2.04907 10.9236 2.42539 11.1153C2.85322 11.3333 3.41327 11.3333 4.53337 11.3333Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailGray);
export default __webpack_public_path__ + "static/media/email_gray.88dffb928ed81f0822226688101c8ae0.svg";
export { ForwardRef as ReactComponent };